/*
 * THE REAL TIME LIST'S COUNTS ARE DERIVED, NEVER ADDED UP (2026-10-30; the "-1" Chris met two mornings running on production).
 * A row's "on site now" number used to be ++'d when a visitor arrived and --'d when one left. Anything that touched the list or the bubbles in between (a filter rebuild that recounted before the
 * new bubble was added, a draw that waited a frame, a reconnect) left the number out of step with the bubbles on the field, and the next departure took it below zero: a visitor flashed in, left, and
 * the row read "Human -1". The same rule as the page occupancy counts and the headline onsite count (CLAUDE.md perf note 10, "a state must never be accumulated across a boundary"): count the bubbles.
 */

/** how many of the given bubbles belong to each category; a bubble with no category counts for none. `leavingId` leaves one visitor out (a departure is counted BEFORE its bubble is removed). */
export const countBubblesByCategory = <T>(bubbles: T[], categoryOf: (bubble: T) => string | null | undefined, leavingId?: string): Map<string, number> => {
  const counts = new Map<string, number>();
  for (const bubble of bubbles) {
    if (leavingId !== undefined && (bubble as { visitor_id?: string }).visitor_id === leavingId) continue;
    const category = categoryOf(bubble);
    if (!category) continue;
    counts.set(category, (counts.get(category) || 0) + 1);
  }

  return counts;
};

/** sets each row's currentUsers to its derived count (0 for a row nobody is in); returns whether any row changed, so the caller only re-sorts and redraws when it must */
export const applyCounts = (rows: Array<{ name: string; currentUsers: number }>, counts: Map<string, number>): boolean => {
  let changed = false;
  for (const row of rows) {
    const n = counts.get(row.name) || 0;
    if (row.currentUsers !== n) {
      row.currentUsers = n;
      changed = true;
    }
  }

  return changed;
};
